import React from 'react';
import { format } from 'date-fns';
import ptBR from 'date-fns/locale/pt-BR';

export function CadastroUsuario({ modalData }) {
  return (
    <div>
      {modalData?.data?.nome ? (
        <span>
          <b>Nome: </b> {modalData?.data?.nome}
        </span>
      ) : (
        ''
      )}

      {modalData?.data?.cpf ? (
        <span>
          <b>, CPF: </b> {modalData?.data?.cpf}
        </span>
      ) : (
        ''
      )}

      {modalData?.data?.email ? (
        <span>
          <b>, E-mail: </b> {modalData?.data?.email}
        </span>
      ) : (
        ''
      )}

      {modalData?.data?.telefone ? (
        <span>
          <b>, Telefone: </b> {modalData?.data?.telefone}
        </span>
      ) : (
        ''
      )}

      {modalData?.data?.cargo ? (
        <span>
          <b>, Cargo: </b> {modalData?.data?.cargo}
        </span>
      ) : (
        ''
      )}

      <span>
        <b>, Situação: </b> {modalData?.data?.ativo ? 'Ativo' : 'Inativo'}
      </span>

      {modalData?.data?.dataCriacao ? (
        <span>
          <b>, Data de criação: </b>{' '}
          {format(
            new Date(`${modalData?.data?.dataCriacao}`),
            'dd/MM/yyyy - HH:mm:ss',
            {
              locale: ptBR,
            }
          )}
        </span>
      ) : (
        ''
      )}
    </div>
  );
}
